<template>
  <div class="component-content configuration-seatclamp">
    <div class="component-content-title mb-4">Select your seat clamp</div>

    <option-list
      :options="seatclampInput"
      :target="this.results.seatclamp"
      :inputName="'setclamp'"
      v-on:target-updated="updateData"
    ></option-list>

    <div class="buttonset">
      <button class="btn btn-outline-dark back-button" v-on:click="goBack">
        back
      </button>
      <finish-configuration-button
        v-if="canFinishConfiguration()"
        v-on:finish-configuration="finishConfiguration"
       ></finish-configuration-button>
      <button class="btn btn-outline-dark next-button" v-on:click="goNext">
        next
      </button>
    </div>
  </div>
</template>

<script>
import Vue from "vue";

import OptionList from "../../shared/optionList.vue";
import FinishConfigurationButton from './finish-configuration-button.vue';

Vue.component("finish-configuration-button", FinishConfigurationButton);

export default {
  name: "configuration-seatclamp",
  data() {
    return {};
  },
  components: {
    OptionList,
  },
  props: ["configuratorSteps", "currentStep", "results", "components"],
  methods: {
    goNext: function () {
      this.$emit("go-next");
    },
    goBack: function () {
      this.$emit("go-back");
    },
    updateData: function (e) {
      this.seatclampInput = e;
    },
    canFinishConfiguration: function() {
// if fork is present, we need to check if the fork is selected and has a colour
        if (this.components.fork?.length > 0) 
        {
          return (
          this.results.frame !== null &&
          this.results.frame !== undefined &&
          this.results.colour !== null &&
          this.results.colour !== undefined &&
          this.results.fork !== null &&
          this.results.fork !== undefined
          );
        }
        else
        {
          // no fork, so we can finish configuration
          return (
            this.results.frame !== null &&
            this.results.frame !== undefined &&
            this.results.colour !== null &&
            this.results.colour !== undefined
          );
        }
    },
    finishConfiguration: function() {
        this.$emit("finish-configuration");
    },
  },
  computed: {
    seatclampInput: {
      get: function () {
        return this.components.seatclamp[0];
      },
      set: function (e) {
        this.$emit("set-seatclamp", e);
      },
    },
  }
};
</script>

<style lang="scss" scoped>
.configuration-seatclamp {
}
</style>

